import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';

import { toast } from 'react-toastify';
//api
import { deleteUser } from 'api/users';
import { getAllUsers } from 'api/pathForHook/users';
//utils
import useHandleSearch from 'utils/customHooks/useHandleSearch';
//components
import CustomTable from 'components/backoffice/customTable';
import DropdownIcons from 'components/backoffice/dropDownIcons';
import DeleteModalCustom from 'components/backoffice/modals/DeleteModalCustom';
import Button from 'components/backoffice/buttonCustom';
import Title from 'components/backoffice/texts/title';
import { usePermissions } from 'components/backoffice/PermissionsContext';
import FiltersTableUsers from './FiltersTableUsers';


const Users = () => {
  const userPermissions = usePermissions();
  const navigate = useNavigate();
  const [listUsers, setListUsers] = useState([]);
  const [formFilter, setFormFilter] = useState({});
  const [page, setPage] = useState(1);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [idItem, setIdItem] = useState();
  const [responseInfo, setResponseInfo] = useState(false);

  const { t } = useTranslation(['backoffice']);

  const { setTitle } = useOutletContext()

  const colsUsers = [
    t('nombreusuario'),
    t('correoelectronico'),
    t('nombre'),
    t('apellido'),
    t('tipousuario'),
    t('activo'),
    t('administrator'),
    t('actions')
  ];

  const { fetchData, stateData, loading } = useHandleSearch();

  const getListUsers = async () => {
    try {
      let payload = {
        page,
        page_size: 10,
        username: formFilter.username || '',
        email: formFilter.email || '',
        full_name: formFilter.full_name || '',
        fields: 'id,username,email,first_name,last_name,profile,active,administrator'
      }
      await fetchData(getAllUsers(), payload);
    } catch (error) {
      console.error(error);
    }
  };



  useEffect(() => {
    setTitle(t('usuarios'))
    return () => {
      setTitle('');
    };
  }, [setTitle])

  useEffect(() => {
    const { results, errors, totalPages, noResults } = stateData;
    if (results !== null) {
      setListUsers(results);
      setResponseInfo({ errors, totalPages, noResults });
    } else {
      setListUsers(null);
      setResponseInfo({ errors });
    }
  }, [stateData])

  useEffect(() => {
    getListUsers();
  }, [page, formFilter]);


  const handleCreate = () => {
    navigate('/intranet/users/create');
  };

  const handleClear = () => {
    setFormFilter({
      username: '',
      email: '',
      full_name: '',
    });
    setPage(1);
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, noResults: false }));
    getListUsers();
  };

  const handleEdit = (id) => {
    navigate(`/intranet/users/edit/${id}`);
  };

  const handleShowModalDelete = (item, id, setOpenModal) => {
    if (item.id === id) {
      setOpenModal(true);
      setIdItem(id);
    }
  };

  const handleDelete = useCallback(async () => {
    try {
      const { status } = await deleteUser(idItem);
      if (status === 204) {
        toast.success(t('eliminadocorrectamente'));
        setFormFilter({
          username: '',
          email: '',
          full_name: '',
        });
      } else {
        toast(`${t('error')} ${status}: ${t('mensajeerror')}`);
      }
    } catch (error) {
      console.log(error);
    }
  }, [openModalDelete]);

  return (
    <div className="d-lg-grid">
      <Title text={t('usuarios')} />
      <Row className="d-flex w-md-100 mt-3">
        <Col md={11} xs={12} className="d-flex text-start">
          <FiltersTableUsers
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            handleClear={handleClear}
            t={t}
            page={page}
            setPage={setPage}
          />
        </Col>
        <Col md={1} xs={12} className="d-flex text-end align-bottom p-md-0 justify-content-end pt-5 pt-md-0">
          {userPermissions.includes('user.__add') && (
            <Button color={'primary'} onClick={handleCreate}>
              {t('crear')}
            </Button>
          )}
        </Col>
      </Row>
      <div className="table-responsive">
        <CustomTable
          cols={colsUsers}
          noResults={responseInfo?.noResults}
          isLoading={loading}
          page={page}
          changePage={setPage}
          totalPages={responseInfo?.totalPages}
        >
          {listUsers &&
            listUsers.map((listUser, index) => {
              return (
                <tr key={listUser.id}>
                  <td>{listUser?.username}</td>
                  <td>{listUser?.email}</td>
                  <td>{listUser?.first_name}</td>
                  <td>{listUser?.last_name}</td>
                  <td>{t(listUser?.profile)}</td>
                  <td>{listUser?.active ? t('si') : t('no')}</td>
                  <td>{listUser?.administrator ? t('si') : t('no')}</td>
                  <td className=" item-dropdown text-end">
                    <DropdownIcons
                      idItem={index}
                      handleDelete={
                        userPermissions.includes('user.__delete')
                          ? () => handleShowModalDelete(listUser, listUser.id, setOpenModalDelete)
                          : undefined
                      }
                      handleEdit={
                        userPermissions.includes('user.__modify') ? () => handleEdit(listUser?.id) : undefined
                      }
                    />
                  </td>
                </tr>
              );
            })}
        </CustomTable>
      </div>
      <DeleteModalCustom
        openModal={openModalDelete}
        setOpenModal={setOpenModalDelete}
        handleDelete={handleDelete}
        deleteTitle={t('deleteuser')}
        beforeTitle={t('usuarios')}
        titleMain={t('usuarios')}
      />
    </div>
  );
};

export default Users;
